export default "__VITE_ASSET__0a40e00b__"